import { defaultTo } from 'ramda';

import { IBalanceInfoSchema } from '../../../repositories/billing-tariffs/entities/PublishTerms/BalanceInfoSchema';

import { ICheckServiceBalance } from '../types';

export const mapBalance = (balanceInfo: IBalanceInfoSchema | undefined): ICheckServiceBalance => ({
  auctionPoints: defaultTo(0, balanceInfo?.auctionPoints),
  totalBalance: defaultTo(0, balanceInfo?.totalBalance),
  canFill: defaultTo(false, balanceInfo?.canFill),
});
